import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isUserLoggedIn = this.auth.currentUserName$.value;
    let idToken: string | null = null;
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        idToken = sessionStorage.getItem('id-token');
      }
    } catch {
      // sessionStorage not available
    }

    if (isUserLoggedIn && idToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `${idToken}`
        }
      });
    }

    // Local dev: rewrite absolute API URLs to relative paths so the proxy forwards them
    const localDev =
      typeof window !== 'undefined' && window.location?.href?.indexOf('.com') === -1;
    const serverlessApi = /api\./.test(request.url);

    if (localDev && serverlessApi) {
      const path = request.url.replace(environment.BASE_URL, '').replace(/^\/*/, '') || '';
      request = request.clone({
        url: path ? `/${path}` : request.url
      });
    }

    return next.handle(request);
  }
}
